import React from 'react'
import PropTypes from 'prop-types'

const Loader = ({ style }) => {
  return (
    <div className='spinner' style={style}>
      <div className='rect1' />
      <div className='rect2' />
      <div className='rect3' />
      <div className='rect4' />
      <div className='rect5' />
    </div>
  )
}

Loader.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.shape({})
}

Loader.defaultProps = {
  style: null
}

export default Loader
